export function HomePage() {
  return (
    <div className="home-page">
      <h1>HRM SaaS - Home</h1>
      {/* TODO: Implement landing page */}
    </div>
  );
}

